export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / k ** i).toFixed(dm)) + ' ' + sizes[i];
};

export const fileSizeInMegaBytes = bytes => {
  return bytes / (1024 * 1024);
};

export const checkFileSizeLimit = (file, maximumUploadLimit) => {
  const fileSize = file?.file?.size || file?.size;
  const fileSizeInMB = fileSizeInMegaBytes(fileSize);
  return fileSizeInMB <= maximumUploadLimit;
};

// `locale` no formato do vue-i18n da tela (pt_BR/en): "52,3 MB" em
// português — o ponto decimal destoava do resto do texto.
export const humanFileSize = (bytes, locale = 'pt_BR') => {
  const n = Number(bytes) || 0;
  const fmt = digits =>
    new Intl.NumberFormat(locale.replace('_', '-'), {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${fmt(0).format(n / 1024)} KB`;
  return `${fmt(1).format(n / (1024 * 1024))} MB`;
};
